import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { removefollowingRider, blockRider, unblockRider, followRider } from "../../../redux/actions/riderNetworkActions";
import { toast } from "react-toastify";

function FollowerStatusControl({
    user,
    subjectUser,
    removefollowingRider,
    blockRider,
    unblockRider,
    followRider
}) {


    const [isBlocked, setIsBlocked] = useState(false);
    const [following, setFollowing] = useState(false);
    //const [rejected, setRejected] = useState(false);
    //const [pending, setPending] = useState(false);


    useEffect(() => {

        if (user.riderNetwork.followers) {
            user.riderNetwork.followers.map(subject => {
                if (subject.userId == subjectUser.userId) {
                    if (subject.blocked) setIsBlocked(true);
                }
            })
        }

        if (user.riderNetwork.following) {
            user.riderNetwork.following.map(subject => {
                if (subject.userId == subjectUser.userId) {
                    setFollowing(true);
                }
            })
        }

    }, [user])

    function followUser(e) {
        e.preventDefault();
        subjectUser.id = subjectUser.userId; 
        followRider(subjectUser);
        setFollowing(true);
        toast.success(`Following ${subjectUser.firstName}`);
    }

    function removeFollower(e) {
        e.preventDefault();
        subjectUser.id = subjectUser.userId; 
        removefollowingRider(subjectUser);
        toast.success(`${subjectUser.firstName} no longer follows you`);
    }

    function blockFollower(e) {
        e.preventDefault();
        subjectUser.id = subjectUser.userId; 
        blockRider(subjectUser);
        setIsBlocked(true);
        toast.success(`${subjectUser.firstName} Blocked`);
    }

    function unblockFollower(e) {
        e.preventDefault();
        subjectUser.id = subjectUser.userId; 
        unblockRider(subjectUser);
        setIsBlocked(false);
        toast.success(`Unblocked ${subjectUser.firstName}`);
    }

    return (
        <div className="profile-status-control">
            { user.id.toUpperCase() == subjectUser.userId.toUpperCase() ? "" :
                !isBlocked ?
                    <div className="dropdown dropleft">
                        <button className="btn btn-link" id="dLabel" type="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                            <span className="fas fa-ellipsis-h more-options"></span>
                        </button>
                        <div className="dropdown-menu" aria-labelledby="dLabel">
                            {!following ?
                                <React.Fragment>
                                    <a className="dropdown-item" onClick={followUser} href="#">Follow</a>
                                    <div className="dropdown-divider"></div>
                                </React.Fragment>
                                : ""}
                            <a className="dropdown-item" onClick={removeFollower} href="#">Remove Follower</a>
                            <a className="dropdown-item" onClick={blockFollower} href="#">Block Follower</a>
                        </div>
                    </div>
                    :
                    <button className="btn btn-info" onClick={unblockFollower}>Unblock</button>
            }
        </div>
    );
};

FollowerStatusControl.propTypes = {
    user: PropTypes.object.isRequired,
    subjectUser: PropTypes.object.isRequired,
    removefollowingRider: PropTypes.func.isRequired,
    blockRider: PropTypes.func.isRequired,
    unblockRider: PropTypes.func.isRequired,
    followRider: PropTypes.func.isRequired
}

function mapStateToProps(state) {
    return {
        user: state.user
    };
}

const mapDispatchToProps = {
    removefollowingRider,
    blockRider,
    unblockRider,
    followRider
}

export default connect(mapStateToProps, mapDispatchToProps)(FollowerStatusControl);



// WEBPACK FOOTER //
// ./src/components/user/profile/FollowerStatusControl.js